import React from 'react';

import { FinalMark } from 'components/Ui/Mark';

const Subject = ({ subject }) => {
	return (
		<div className="flex items-center">
			<div className="flex-1">
				{subject.title}
			</div>
			
			<FinalMark mark={subject.mark} />
		</div>
	);
};

export default Subject;